import { Select as SelectPrimitive } from "radix-ui"

import { Icon } from "../Icon"
import { Text } from "../Text"
import styles from "./SelectGhostTrigger.module.css"

/**
 * A discreet, ghost-like button trigger without any background, border, hover/focus indicator.
 * Use this instead of the default trigger when a direct parent of the Select is already handling these concerns.
 */

interface Props {
  id: string
  disabled?: boolean
  placeholder?: string
}

export function SelectGhostTrigger(props: Props) {
  const { id, disabled, placeholder } = props

  return (
    <SelectPrimitive.Trigger asChild disabled={disabled} id={id}>
      <button className={styles.root} disabled={disabled}>
        <Text>
          <SelectPrimitive.Value placeholder={placeholder} />
        </Text>
        <Icon name="unfoldMore" color="grey11" size="small" />
      </button>
    </SelectPrimitive.Trigger>
  )
}
